export default "__VITE_ASSET__AGJXGttT__"